import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";

const DEFAULT_URL = "https://test2.acrossassist.in/";

function QrCodeUrl() {
  const [url, setUrl] = useState(DEFAULT_URL);
  const [inputValue, setInputValue] = useState(DEFAULT_URL);

  const handleGenerate = (e) => {
    e.preventDefault();
    setUrl(inputValue);
  };

  return (
    <div style={{ maxWidth: 350, margin: "2rem auto", padding: 32, borderRadius: 12, background: "#f8fafc", boxShadow: "0 8px 24px rgba(0,0,0,0.08)" }}>
     
      {url && (
        <div style={{ textAlign: "center" }}>
          <QRCodeCanvas value={url} size={192} />
          {/* <div style={{ marginTop: 10, fontSize: 14, color: "#64748b" }}>{url}</div> */}
        </div>
      )}
    </div>
  );
}

export default QrCodeUrl;
